import { get } from 'lodash';
import { getUserInfoWithCache } from '@/api/cacheRequest';
import { storage } from '@/utils';

import actionTypes from './actionType';

export const toggleLoading = (state) => {
  return {
    type: actionTypes.TOGGLE_LOADING,
    payload: state,
  };
};

export const updateShortcutConfig = (state) => {
  return {
    type: actionTypes.UPDATE_SHORTCUT_CONFIG,
    payload: state,
  };
};

export const initSubmenu = (state) => {
  return {
    type: actionTypes.INIT_SUBMENU,
    payload: state,
  };
};

export const toggleSiderCollapsed = (state) => {
  return {
    type: actionTypes.TOGGLE_SIDER_COLLAPSED,
    payload: { siderCollapsed: state },
  };
};

// 提取menu里的permission
const extractMenuPermission = (menuList) => {
  const result: string[] = [];

  const getItemPermission = (menuItem) => {
    const { permissions, children } = menuItem;
    (permissions || []).forEach((item) => {
      result.push(item.code);
    });
    (children || []).forEach((subMenu) => {
      getItemPermission(subMenu);
    });
  };

  (menuList || []).forEach((item) => {
    getItemPermission(item);
  });

  return result;
};

export const useGroupCurrentEmployee = () => {
  return async (dispatch, getState) => {
    const { companyGroup = {} } = getState().user;
    const employeeNo = get(companyGroup, 'employeeNo', '');
    const name = get(companyGroup, 'name', '');
    const userId = get(companyGroup, 'userId', '');
    const postName = get(companyGroup, 'postName', '');
    const permissions = get(companyGroup, 'permissions', []);
    const roles = get(companyGroup, 'roles', []);
    const menus = get(companyGroup, 'menus', []);
    const departmentType = get(companyGroup, 'departmentType', null);
    const departmentCodeList = get(companyGroup, 'departmentCodeList', []);

    dispatch({
      type: actionTypes.CACHE_USER_INFO,
      payload: {
        userInfo: {
          employeeNo,
          name,
          userId,
          postName,
        },
        permissions,
        roles,
        menus,
        departmentType,
        departmentCodeList,
      },
    });
  };
};

// 用户菜单
const parseUserMenuList = (list) => {
  const shortcutMenuList = [];
  const layoutMenuList = [];
  (list || []).forEach((item) => {
    if (item.path === 'PMS_SHORTCUT_SIDE_MENU') {
      // 快捷菜单
      shortcutMenuList.push(item);
    } else {
      layoutMenuList.push(item);
    }
  });

  return {
    layoutMenuList,
    shortcutMenuList,
  };
};

export const getCurrentEmployee = () => {
  return async (dispatch) => {
    dispatch(toggleLoading('currentEmployeeLoading'));
    try {
      const res = await getUserInfoWithCache();
      if (res.code === 0) {
        const employeeNo = get(res, 'data.employeeNo', '');
        const name = get(res, 'data.name', '');
        const userId = get(res, 'data.userId', '');
        const postName = get(res, 'data.postName', '');
        const roles = get(res, 'data.roles', []);
        const shops = get(res, 'data.shops', []) || [];
        const menus = get(res, 'data.menus', []);
        const commonCode = storage.get('commonCode');
        const currentShop = shops.find((item) => commonCode === item.commonCode);

        const departmentType = get(res, 'data.departmentType', null);
        const departmentCodeList = get(res, 'data.departmentCodeList', []);
        const companyGroup = get(res, 'data.companyGroup', null);

        const permissions = [].concat(
          get(res, 'data.permissions') || [], // 门店权限
          get(companyGroup, 'permissions') || [], // 集团权限
          extractMenuPermission(menus || []), // 门店菜单
          extractMenuPermission(get(companyGroup, 'menus') || []), // 集团菜单
        );

        dispatch(toggleLoading('currentEmployeeLoading'));

        // 如果已经选择了集团登录
        if (storage.get('isGroupLogin')) {
          const employeeNoG = get(companyGroup, 'employeeNo', '');
          const nameG = get(companyGroup, 'name', '');
          const userIdG = get(companyGroup, 'userId', '');
          const postNameG = get(companyGroup, 'postName', '');
          const rolesG = get(companyGroup, 'roles', []);
          const menusG = get(companyGroup, 'menus', []);
          const departmentTypeG = get(companyGroup, 'departmentType', null);
          const departmentCodeListG = get(companyGroup, 'departmentCodeList', []);
          const groupMenu = parseUserMenuList(menusG);
          dispatch({
            type: actionTypes.CACHE_USER_INFO,
            payload: {
              userInfo: {
                employeeNo: employeeNoG,
                name: nameG,
                userId: userIdG,
                postName: postNameG,
              },
              permissions,
              roles: rolesG,
              menus: groupMenu.layoutMenuList,
              departmentType: departmentTypeG,
              departmentCodeList: departmentCodeListG,
              shortcutMenuList: groupMenu.shortcutMenuList,
              companyGroup,
              shops,
            },
          });
          return Promise.resolve({ shops, hasGroupPermission: !!companyGroup });
        }

        const storeMenu = parseUserMenuList(menus);
        // 非集团登录
        dispatch({
          type: actionTypes.CACHE_USER_INFO,
          payload: {
            userInfo: {
              employeeNo,
              name,
              userId,
              postName,
            },
            permissions,
            roles,
            shops,
            menus: storeMenu.layoutMenuList,
            currentShop,
            shortcutMenuList: storeMenu.shortcutMenuList,
            departmentType,
            departmentCodeList,
            companyGroup,
          },
        });
        return Promise.resolve({ shops, hasGroupPermission: !!companyGroup });
      }
      dispatch(toggleLoading('currentEmployeeLoading'));
      return Promise.reject();
    } catch (error) {
      //
      dispatch(toggleLoading('currentEmployeeLoading'));
      return Promise.reject();
    }
  };
};
